import type { FinancePaymentMethod } from '@/services';

/**
 * Forma do gateway (Finance.API) → rótulo. Usado na aba Cobrança da apólice e
 * na tela de formas de pagamento do produto; os rótulos são os mesmos que o
 * BFF grava no "de/para" da auditoria ("Oferecer Boleto PIX").
 */
export const FINANCE_METHOD_LABELS: Record<FinancePaymentMethod, string> = {
  PIX: 'PIX',
  CREDIT_CARD: 'Cartão de crédito',
  BOLETO_PIX: 'Boleto PIX',
};

/** Rótulo de uma forma vinda da API; um valor desconhecido aparece cru. */
export function financeMethodLabel(method: string): string {
  return FINANCE_METHOD_LABELS[method as FinancePaymentMethod] ?? method;
}
